import { validateField, validateForm } from '../../../utils/form-validator-utils';
import React, { useState } from 'react';
import signUpImage from '../../../assets/images/loginImgnew.png';
import logo from '../../../assets/images/logo-trans.png';
import Form from './form';
// import Container from '../../../components/shared/container';
import { useNavigate } from 'react-router-dom';
import { createUser } from '../../../services/auth-service';

const SignUp = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        // username: '',
        email: '',
        password: '',
        confirmPassword: '',
        msisdn: ''
    });

    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        msisdn: '',
        apiError: ''
    });

    const [successMessage, setSuccessMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Validate on change if there's already an error
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: validateField(name, value, formData.password)
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting || successMessage) return;
        const { errors: validationErrors, isValid } = validateForm(formData, [
            'firstName', 'lastName',
            // 'username', 
            'email', 'password', 'confirmPassword', 'msisdn'
        ]);
        setErrors({ ...validationErrors, apiError: '' });
        setSuccessMessage('');
        if (!isValid) return;

        setIsSubmitting(true);
        try {

            console.log(formData)

            const response = await createUser(formData);
            if (response.success) {
                // Create complete user object with email
                const userData = {
                    ...response.data.data.user,
                    email: formData.email
                };
                localStorage.setItem('authToken', response.data.data.token);
                localStorage.setItem('refreshToken', response.data.data.refreshToken);
                localStorage.setItem('signupKeys', response.data.data.verificationKey);
                localStorage.setItem('user', JSON.stringify(userData));
                setSuccessMessage(response.data.message || 'Registration successful! Please check your email for verification.');
                setTimeout(() => {
                    navigate('/dashboard');
                }, 2000);
            } else {
                setErrors(prev => ({
                    ...prev,
                    apiError: response.data.message || 'Registration failed. Please try again.'
                }));
            }
        } catch (error) {
            setErrors(prev => ({
                ...prev,
                apiError: error.message || 'An unexpected error occurred. Please try again.'
            }));
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="grid bg-bg  md:grid-cols-2 grid-cols-1 !px-0 gap-6 min-h-screen">
            <div className='p-8 md:flex hidden'>
                <img src={signUpImage} className='w-full h-full object-contain' alt="Sign up illustration" />
            </div>
            <div className='flex bg-white justify-start py-6 sm:px-8 px-4'>
                <div className='flex flex-col items-center justify-center xl:w-[75%] lg:w-[85%] w-full'>
                    <img
                        src={logo}
                        className="h-9 object-contain"
                        alt="Logo"
                    />

                    <div className='w-full mt-3'>
                        <h2 className='sm:text-xl text-lg text-center font-bold text-gray-800 mb-6'>Create your account</h2>
                        {successMessage && (
                            <div
                                className="mb-4 p-3 bg-green-100 text-green-700 text-sm rounded-lg text-center"
                                role="alert"
                            >
                                {successMessage}
                            </div>
                        )}
                        {errors.apiError && (
                            <div
                                className="mb-4 p-3 bg-red-100 text-red-700 text-sm rounded-lg text-center"
                                role="alert"
                            >
                                {errors.apiError}
                            </div>
                        )}
                        <Form
                            handleSubmit={handleSubmit}
                            formData={formData}
                            handleChange={handleChange}
                            errors={errors}
                            isSubmitting={isSubmitting}
                            successMessage={successMessage}
                        />
                    </div>

                    <p className='text-gray-400 text-center mt-4 text-sm'>© 2025 YoGPS™. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
};

export default SignUp;